import styled from 'styled-components';

const BulletList = styled.ul`
  & li {
    list-style-type: disc;
  }
`;

export { BulletList };
